module.exports = __webpack_public_path__ + "static/img/cocina_01.bf5cf9e9.jpeg";